<template>
  <div class="stat-cards">
    <div class="stat-cards__card">
      <p class="stat-cards__value">{{ stats.totalCourses.currentMonth }}</p>
      <StatIcon :stat="stats.totalCourses" />
      <p class="stat-cards__label">Courses viewed</p>
    </div>
    <div class="stat-cards__card">
      <p class="stat-cards__value">{{ stats.numVideosWatched.currentMonth }}</p>
      <StatIcon :stat="stats.numVideosWatched" />
      <p class="stat-cards__label">Videos viewed</p>
    </div>
    <div class="stat-cards__card">
      <p class="stat-cards__value">
        {{ statTimeFormatted(stats.totalTime.currentMonth) }}
      </p>
      <StatIcon :stat="stats.totalTime" />
      <p class="stat-cards__label">Total time watched</p>
    </div>
    <div class="stat-cards__card">
      <p class="stat-cards__value">
        {{ statTimeFormatted(stats.monthTimeWatched.currentMonth) }}
      </p>
      <StatIcon :stat="stats.monthTimeWatched" />
      <p class="stat-cards__label">Watched this month</p>
    </div>
  </div>
</template>

<script>
import StatIcon from '@/components/user-dashboard/pass-analytics/StatIcon.vue'

export default {
  name: 'StatCards',
  components: {
    StatIcon,
  },
  props: {
    stats: {
      type: Object,
      required: true,
    },
  },
  methods: {
    statTimeFormatted(value) {
      const timeFormatted = value
        ? this.$duration.durationOn(
            this.$duration.hhmmss(value * 60, 'HOURSMIN')
          )
        : 0
      return timeFormatted
    },
  },
}
</script>

<style lang="scss" scoped>
.stat-cards {
  display: flex;
  border-radius: 12px;
  padding: 20px;
  background: var(--glass-mid-gray);
  flex-wrap: wrap;
  margin-bottom: 20px;
  @include mobile {
    flex-wrap: nowrap;
    margin-bottom: 30px;
    padding: 14px 32px 16px 42px;
  }
  &__card {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex-wrap: wrap;
    margin: 0 10px 10px 10px;
    padding: 14px;
    background: var(--glass-mid-gray);
    width: 100%;
    border-radius: 12px;
    flex: 0 1 calc(50% - 20px);
    @include mobile {
      justify-content: flex-start;
      text-align: start;
    }
    &:nth-child(3),
    &:nth-child(4) {
      flex: 0 1 100%;
      @include mobile {
        flex: 1 1 25%;
      }
    }
    @include mobile {
      flex: 1 1 25%;
      margin: 0 10px;
    }
  }
  &__label {
    width: 100%;
    font-size: rem(12);
    line-height: 14px;
    font-family: var(--font-bold);
    color: var(--light-blue-gray);
    margin: 0;
  }
  &__value {
    font-family: var(--font-bold);
    color: var(--white);
    font-size: rem(40);
    line-height: 52px;
    margin-bottom: 5px;
    flex: 0 0 22px;
  }
}
</style>
